// @ts-nocheck
import { InvoiceSummaryModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { invoiceSummarySelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPISelectors";
import { useSelector } from "react-redux";

const useInvoiceSummaryState = () => {
    const invoiceSummary = useSelector(invoiceSummarySelector);
    const dispatch = useBunzlDispatch();
    const setInvoiceSummary = (invoiceSummary: InvoiceSummaryModel | undefined) => {
        dispatch({
            type: "Store/Pages/invoiceSummarys/LoadInvoiceSummary",
            report: invoiceSummary,
            parameter: invoiceSummary,
        });
    };
    return [invoiceSummary, setInvoiceSummary] as const;
};
export default useInvoiceSummaryState;
